module.exports = __webpack_public_path__ + "static/media/all.b42ece20.pred";